import { GeoReportMap, GeoReportTable } from "@components";
import { History, Location } from "history";
import * as React from "react";
import { ChartPlaceholder } from "./ChartPlaceholder";
import { ReportLayout } from "./ReportLayout";

export interface GeographicReportPageProps {
    history: History;
    location: Location;
}

export function GeographicReportPage(props: GeographicReportPageProps) {
    return (
        <ReportLayout subtitle="Geographic reports" history={props.history} location={props.location}>
            <ChartPlaceholder size="full">
                <GeoReportMap />
            </ChartPlaceholder>
            <ChartPlaceholder size="full">
                <GeoReportTable />
            </ChartPlaceholder>
        </ReportLayout>
    );
}
